import { supabase } from './supabaseClient';

// --- Initial Data Copied from App.tsx ---

const projectInfo = {
    name: 'Achs Las Condes',
    startDate: '2026-01-05',
    endDate: '2026-12-31'
};

const profiles = [
    { id: 'p1', name: 'Administrador', permissions: { 'can_edit_budget': true, 'can_approve_ep': true } },
    { id: 'p2', name: 'Jefe de Obra', permissions: { 'can_edit_budget': false, 'can_approve_ep': true } },
    { id: 'p3', name: 'Supervisor', permissions: { 'can_edit_budget': false, 'can_approve_ep': false } },
];

const tasks = [
    {
        id: '1',
        name: 'OBRA GRUESA',
        type: 'folder',
        expanded: true,
        start: '2026-01-05',
        end: '2026-02-15',
        duration: 42,
        children: [
            { id: '1-1', name: 'Enfierradura', type: 'task', start: '2026-01-05', end: '2026-01-15', duration: 11, progress: 100 },
            { id: '1-2', name: 'Moldaje', type: 'task', start: '2026-01-10', end: '2026-01-20', duration: 11, progress: 60 },
            { id: '1-3', name: 'Hormigón', type: 'task', start: '2026-01-18', end: '2026-01-25', duration: 8, progress: 0 },
        ]
    },
    {
        id: '2',
        name: 'TERMINACIONES',
        type: 'folder',
        expanded: true,
        start: '2026-02-01',
        end: '2026-03-30',
        duration: 58,
        children: [
            { id: '2-1', name: 'Tabiquería', type: 'task', start: '2026-02-01', end: '2026-02-15', duration: 15, progress: 0 },
            { id: '2-2', name: 'Pavimentos', type: 'task', start: '2026-02-10', end: '2026-02-28', duration: 19, progress: 0 },
        ]
    }
];

const levels = [
    { id: '1', name: 'Piso 1' },
    { id: '2', name: 'Piso 2' },
    { id: '3', name: 'Piso 3' },
];

const units = [
    { id: 'u1', code: '001', name: 'Dpto 101', levelId: '1' },
    { id: 'u2', code: '002', name: 'Dpto 102', levelId: '1' },
    { id: 'u3', code: '003', name: 'Dpto 103', levelId: '1' },
    { id: 'u4', code: '004', name: 'Dpto 104', levelId: '1' },
    { id: 'u6', code: '006', name: 'Dpto 201', levelId: '2' },
];

const responsibles = [
    { id: 'r1', name: 'Juan Pérez', rut: '12.345.678-9', email: 'juan@klyd.cl', role: 'Capataz' },
    { id: 'r2', name: 'Maria Silva', rut: '9.876.543-2', email: 'maria@klyd.cl', role: 'Jefe de Obra' },
    { id: 'r3', name: 'Pedro Diaz', rut: '15.555.444-k', email: 'pedro@klyd.cl', role: 'Subcontrato' },
];

const weeklyPlans = [
    { id: 1, startDate: '2026-01-19', endDate: '2026-01-23', status: 'En Ejecución', allocations: [] }
];

const subcontractors = [
    { id: '1', rut: '76.543.210-K', razonSocial: 'Electricidad Global Ltda.', giro: 'Instalaciones Eléctricas', representante: 'Carlos Saavedra', telefono: '+56912345678', correo: 'contacto@elecglobal.cl' },
    { id: '2', rut: '88.999.111-2', razonSocial: 'Constructora del Sur SpA', giro: 'Movimiento de Tierras', representante: 'Ana María López', telefono: '+56987654321', correo: 'proyectos@consur.cl' }
];

const contracts = [
    {
        id: 'ctr-001',
        subcontractorId: '1',
        startDate: '2026-01-01',
        endDate: '2026-06-30',
        retention: 5,
        status: 'Activo',
        totalAmount: 5000000,
        items: []
    }
];

const budgetProjects = [
    { id: 'p1', name: 'Edificio Central' },
    { id: 'p2', name: 'Estacionamientos' }
];

const budgetResources = [
    { id: 'r1', projectId: 'p1', code: 'MAT-001', description: 'Cemento Portland Tipo I (42.5kg)', type: 'Material', unit: 'saco', costAccount: '2001' },
    { id: 'r2', projectId: 'p1', code: 'MAT-002', description: 'Arena Lavada', type: 'Material', unit: 'm3', costAccount: '2002' },
    { id: 'r3', projectId: 'p1', code: 'MO-001', description: 'Maestro Albañil', type: 'MOD', unit: 'hh', costAccount: '3005' },
    { id: 'r4', projectId: 'p1', code: 'EQ-005', description: 'Retroexcavadora', type: 'Equipo', unit: 'hm', costAccount: '4010' },
    { id: 'r5', projectId: 'p1', code: 'MAT-003', description: 'Agua Industrial', type: 'Material', unit: 'ltr', costAccount: '2003' },
];

const budgetItems = [
    {
        id: 'item-1',
        folderId: '1-1-1',
        code: 'STR-001',
        description: "Hormigón f'c=210kg/cm2 (Cimientos)",
        unit: 'm3',
        quantity: 120,
        unitPrice: 107.40,
        ganttTaskId: '1-3'
    },
    {
        id: 'item-2',
        folderId: '1-1-1',
        code: 'STR-002',
        description: "Acero de Refuerzo Grado 60",
        unit: 'kg',
        quantity: 2500,
        unitPrice: 3.00,
        ganttTaskId: '1-1'
    }
];

const apuData = {
    'item-1': [
        { id: 'apu-1', resourceId: 'r1', quantity: 1, unitPrice: 60, selectedForEDT: true },
        { id: 'apu-2', resourceId: 'r2', quantity: 1.1, unitPrice: 9, selectedForEDT: true },
        { id: 'apu-3', resourceId: 'r3', quantity: 2.5, unitPrice: 15, selectedForEDT: false },
    ]
};

const budgetTree = [
    {
        id: '1',
        name: 'Costo Directo',
        expanded: true,
        children: [
            {
                id: '1-1',
                name: 'Obra Gruesa',
                expanded: true,
                children: [
                    { id: '1-1-1', name: 'Fundaciones', children: [], expanded: false, isSelected: true },
                    { id: '1-1-2', name: 'Columnas', children: [], expanded: false }
                ]
            }
        ]
    }
];

const subcontractTypes = [
    { id: 'st1', name: 'Instalaciones Eléctricas' },
    { id: 'st2', name: 'Movimiento de Tierras' },
    { id: 'st3', name: 'Obra Gruesa' },
];

// --- Seeding Function ---

export const seedDatabase = async () => {
    console.log("Starting Corrected Seeding Process...");

    // Helper: Si es array, lo envuelve en { list: array }, si no lo deja igual.
    const createPayload = (collection: string, docId: string, payload: any) => ({
        collection_name: collection,
        doc_id: docId,
        payload: Array.isArray(payload) ? { list: payload } : payload,
        updated_at: new Date().toISOString()
    });

    const globalProjects = [
        { id: '1', name: 'Achs Las Condes', startDate: '2026-01-05', endDate: '2026-12-31', status: 'Active' },
        { id: '2', name: 'Edificio Kennedy', startDate: '2026-02-15', endDate: '2026-11-20', status: 'Active' }
    ];

    const companyConfig = {
        name: 'Constructora LD',
        rut: '',
        razonSocial: '',
        direccion: '',
        logo: undefined
    };

    const rows = [
        // --- DATA GLOBAL (collection_name = 'data') ---
        createPayload('data', 'projects', globalProjects),
        createPayload('data', 'globalProfiles', profiles),
        createPayload('data', 'globalUsers', []), // Se creará automáticamente al iniciar sesión
        createPayload('data', 'companyConfig', companyConfig),
        
        // --- DATA ESPECÍFICA DE LA OBRA 1 (collection_name = 'project_1') ---
        createPayload('project_1', 'projectInfo', projectInfo),
        createPayload('project_1', 'tasks', tasks),
        createPayload('project_1', 'levels', levels),
        createPayload('project_1', 'units', units),
        createPayload('project_1', 'responsibles', responsibles),
        createPayload('project_1', 'weeklyPlans', weeklyPlans),
        createPayload('project_1', 'subcontractors', subcontractors),
        createPayload('project_1', 'contracts', contracts),
        createPayload('project_1', 'budgetProjects', budgetProjects),
        createPayload('project_1', 'budgetResources', budgetResources),
        createPayload('project_1', 'budgetItems', budgetItems),
        createPayload('project_1', 'apuData', apuData),
        createPayload('project_1', 'budgetTree', budgetTree),
        createPayload('project_1', 'subcontractTypes', subcontractTypes),
        createPayload('project_1', 'matrixData', {}),
        createPayload('project_1', 'protocolConfigs', {}),
        createPayload('project_1', 'savedProtocols', {}),
        createPayload('project_1', 'lookaheadPlans', []),
        createPayload('project_1', 'paymentStatements', [])
    ];

    try {
        const { error } = await supabase.from('app_data').upsert(rows, { onConflict: 'collection_name,doc_id' });
        
        if (error) throw error;
        
        console.log("Database Seeded with Proper Scope Successfully!");
        alert("¡Base de datos K-LyDapp inyectada con ÉXITO corrigiendo sus divisiones de arquitectura!");
    } catch (e) {
        console.error("Error seeding database:", e);
        alert("Error seeding database: " + e);
    }
};
